import { useEffect, useLayoutEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { isSaintVincent } from '../utils/localizeDomain.js';

// Advertencia de riesgo obligatoria (anuncio de valores).
// Requisitos: visible en la parte superior de cada página, permanece visible al
// hacer scroll (fija), encerrada en un recuadro con borde y texto en negrita.
// Mide su propia altura y la publica en `--risk-warning-height` para que el menú
// fijo y el contenido se desplacen hacia abajo sin solaparse.
// Se muestra en todos los entornos EXCEPTO Saint Vincent (SVG / excentcapital.com).
const RiskWarning = () => {
  const { t } = useTranslation('riskWarning');
  const ref = useRef(null);
  const hidden = isSaintVincent();

  useLayoutEffect(() => {
    if (hidden) return;
    const el = ref.current;
    if (!el || typeof document === 'undefined') return;

    const setHeight = () => {
      const h = el.offsetHeight;
      document.documentElement.style.setProperty('--risk-warning-height', `${h}px`);
    };

    setHeight();

    let observer;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(setHeight);
      observer.observe(el);
    }
    window.addEventListener('resize', setHeight);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', setHeight);
    };
  }, [hidden]);

  // Limpia la variable si el componente se desmonta.
  useEffect(() => {
    return () => {
      if (typeof document !== 'undefined') {
        document.documentElement.style.removeProperty('--risk-warning-height');
      }
    };
  }, []);

  if (hidden) return null;

  return (
    <div
      ref={ref}
      role="alert"
      aria-label={t('label')}
      className="fixed top-0 left-0 z-[1000000] w-full bg-blueMenu dark:bg-primaryBg px-[5%] py-4"
    >
      <p className="mx-auto max-w-[1400px] text-center text-white text-[0.7rem] leading-snug font-bold sm:text-[0.78rem]">
        {t('text')}
      </p>
    </div>
  );
};

export default RiskWarning;
